import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth'
import operations from '@/store/modules/operations'
import messages from '@/store/modules/messages'
import settings from '@/store/modules/settings'
import rewards from '@/store/modules/rewards'
import entityRewards from '@/store/modules/entityRewards'
import alerts from '@/store/modules/alerts'
import banners from '@/store/modules/banners'
import attachments from '@/store/modules/attachments'
import externalRegistrationModal from '@/store/modules/externalRegistrationModal'
import navigation from '@/store/modules/navigation'
import browser from '@/store/modules/browser'
import datePicker from '@/store/modules/datePicker'
import pageModal from '@/store/modules/pageModal'
import account from '@/store/modules/account'
import goals from "@/store/modules/goals";
import quizzes from "@/store/modules/quizzes";
import surveys from "@/store/modules/surveys";
import polls from "@/store/modules/polls";
import visitrecorder from "@/store/modules/visitrecorder";
import createPersistedState from 'vuex-persistedstate'
import { entityUuidFromLocation } from '@/utils/EntityUuid';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    operations,
    messages,
    settings,
    entityRewards,
    rewards,
    alerts,
    banners,
    attachments,
    externalRegistrationModal,
    navigation,
    browser,
    datePicker,
    pageModal,
    account,
    goals,
    quizzes,
    surveys,
    polls,
    visitrecorder
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'ls-member-module-' + entityUuidFromLocation(),
      paths: [
        'alerts.dismissedAlerts',
        'auth.isAuthorized',
        'auth.token',
        'auth.user',
        'auth.entity.uuid',
        'auth.agreements',
        'settings',
        'banners',
        'navigation',
        'account',
        'visitrecorder',
      ]
    })
  ]
});
